import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import _ from '@app/utils.js'

_.onElementArrive('.page-node-type-page-product .product-slideshow', el => {
  new Swiper(el, {
    modules: [Navigation, Pagination],
    loop: true,
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
  })
})

_.onElementArrive('.page-node-type-page-product #materials', el =>
  el.querySelectorAll('.material').forEach(materialSection => {
    const previewEl = materialSection.querySelector('.preview')
    materialSection.querySelectorAll('.material-colors .diemmebi-color').forEach(colorEl => {
      colorEl.style.cursor = 'pointer'
      colorEl.addEventListener('click', () => {
        previewEl.innerHTML = colorEl.outerHTML
      })
    })
  })
)
